import authAxiosInstance from "@/sevices/authAxiosInstance";
import { SortOrder } from "@/types/common";
import { OrderList, OrderSortableColumnKeys } from "@/types/Order";

interface GetOrdersBySoldToIdRequestParams {
  userId: string;
  soldToId: string;
  pageSize?: number;
  pageStartKey?: string;
  sortBy?: OrderSortableColumnKeys;
  sortOrder: SortOrder;
  year?: string;
}

export const getOrdersBySoldToId = async ({
  userId,
  soldToId,
  pageSize,
  pageStartKey,
  sortBy,
  sortOrder,
  year
}: GetOrdersBySoldToIdRequestParams): Promise<OrderList> => {
  try {
    const res = await authAxiosInstance({
      url: `orderservice/orders/user/${userId}/soldToOrg/${soldToId}`,
      method: "GET",
      params: {
        pageSize,
        pageStartKey,
        sortBy,
        sortOrder,
        year
      }
    });
    return res?.data;
  } catch (error) {
    throw error;
  }
};
